import React, { useMemo } from 'react'
import { useFormikContext } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { push } from 'connected-react-router'

import Button from '../../utils/Button'

const RequestFormSteps = ({ currentStep, goStep }) => {
  const dispatch = useDispatch()
  const requestForm = useFormikContext()

  const facility = useSelector(store => store.facilities.facility)
  const isAuthenticated = useSelector(store => store.session.isAuthenticated)

  const nextStep = () => requestForm.submitForm()

  const prevStep = () => {
    goStep(currentStep - 1)
  }

  const saveForm = () => {
    currentStep < 3 && goStep(3) // bit of a hack, if on step 2 it flashes step 3 before saving. Its not possible to pass attrs or state to formik submitForm
    nextStep()
  }

  const quitForm = () => {
    dispatch(push(`/${requestForm.values.uuid}`))
  }

  const isUpdate = useMemo(() => !!requestForm.values.uuid, [requestForm.values.uuid])
  const previousDisabled = useMemo(() => (currentStep === 1) || (isUpdate && currentStep === 2), [isUpdate, currentStep] )

  const step_titles = ['_padding_', 'Location', 'Dates', 'Options', 'Notifications']

  return (
    <>
      <div className="flex items-center mb-6 mt-2 space-x-6 md:space-x-12">
        <button
          type="button"
          onClick={() => prevStep()}
          className="disabled:opacity-30 cursor-point disabled:cursor-not-allowed"
          disabled={previousDisabled}
        >
          <FontAwesomeIcon icon={faAngleLeft} className="text-4xl sm:text-6xl text-gray-500  " />
        </button>
        <div className="flex-grow">
          <h2 className="text-lg sm:text-3xl">
            Step {currentStep} of {isAuthenticated ? '3' : '4'}: {step_titles[currentStep]}
          </h2>
          <h5 className="text-md sm:text-xl text-gray-500">{currentStep > 1 && requestForm.values.facilityId && facility?.name}</h5>
        </div>

        {isUpdate && (
          <div className="flex-grow hidden md:inline">
            <Button className="w-full" color="gray" onClick={quitForm}>
              Cancel
            </Button>
          </div>
        )}
        {isUpdate && (
          <div className="flex-grow hidden md:inline">
            <Button className="w-full" color="darkGreen" onClick={saveForm}>
              Save
            </Button>
          </div>
        )}
        {(isUpdate || (facility && facility.id && currentStep === 1)) && (
          <FontAwesomeIcon
            icon={faAngleRight}
            onClick={() => nextStep()}
            className="text-right text-4xl sm:text-6xl text-gray-500 cursor-pointer"
          />
        )}
      </div>
      {isUpdate && (
        <div className="flex items-center mb-6 mt-2 space-x-6 md:hidden">
          <div className="flex-grow">
            <Button className="w-full" color="gray" onClick={quitForm}>
              Cancel
            </Button>
          </div>

          <div className="flex-grow">
            <Button className="w-full" color="darkGreen" onClick={saveForm}>
              Save
            </Button>
          </div>
        </div>
      )}
    </>
  )
}

export default RequestFormSteps
